// extracted by mini-css-extract-plugin
export default {"wrapper":"CUtl6mAtftOHqMdu_e7o","period":"iM4U64tQLQYdlPBJ5_9g"};